import { combineReducers } from 'redux';
import adminReducer from './adminReducer';
import comicReducer from './comicReducer';
import chapterReducer from './chapterReducer';
import genreReducer from './genreReducer';
import userReducer from './userReducer';
import settingReducer from './settingReducer';

const rootReducer = combineReducers(
  {
    adminReducer,
    comicReducer,
    chapterReducer,
    genreReducer,
    userReducer,
    settingReducer
  }
);

export default rootReducer;